<p-sidebar [(visible)]="visible" class="ss-g-custom-sidebar-width ss-l-class-metaApp" position="right"
    [modal]="!isMobile" (onHide)="visibleChange.emit(false); close.emit()" [style]="{
    'display': 'flex',
    'flex-direction': 'column'
  }">

    <ng-template pTemplate="header">
        <h4 class="mb-0">Apps &gt; Google analytics 4</h4>
    </ng-template>

    <div style="flex:1 1 auto; overflow-y:visible" class="sidebar-content">
        <app-feed-help [text]="'Ga4'" [videoUrl]="'https://youtube.com/video-analytics'"
            [supportUrl]="'https://meusite.com/suporte'">
        </app-feed-help>

        <ng-container *ngIf="!loading; else sidebarSkeleton">
        <!-- Contas -->
        <ng-container *ngIf="(ga4Accounts?.length || 0) > 0; else ctaGa4">
            <div class="card shadow-none">
                <div class="text-900 text-xl font-semibold mb-4">
                    Conta Ativa
                </div>

                <!-- Exibe cada conta (NÃO exibe propriedade aqui) -->
                <div *ngFor="let acct of ga4Accounts; trackBy: trackByUid" class="card shadow-none"
                    style="position:relative;">

                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-sm p-button-primary text-sm"
                        style="position:absolute; top:-0.5rem; right:-0.5rem; width:1.75rem; height:1.75rem; border-radius:4px; z-index:10; padding:0;"
                        (click)="onRemoveGa4Account(acct)">
                    </button>

                    <div class="flex align-items-center justify-content-between">
                        <div class="flex align-items-center gap-2">
                            <img [src]="acct.picture || 'assets/analytics-icon.png'" alt="avatar"
                                style="width:32px; height:32px; border-radius:12%;" />
                            <div>
                                <div class="font-semibold">{{ acct.accountName || acct.email }}</div>
                                <div class="text-xs text-secondary-300">{{ acct.email }}</div>
                            </div>
                        </div>
                        <i class="pi pi-check-circle text-green-600 text-lg" *ngIf="acct.status === 'active'"></i>
                    </div>
                </div>

                <!-- Título do bloco propriedades -->
                <div class="text-900 text-xl font-semibold mb-4">
                    Propriedades
                    <span *ngIf="ga4Accounts?.length" class="text-sm text-secondary-400">
                        ({{ getTotalProperties() }})
                    </span>
                </div>

                <!-- Exibe multiselect apenas uma vez por conta (abaixo da conta) -->
                <div *ngFor="let acct of ga4Accounts; trackBy: trackByUid" class="shadow-none"
                    style="position:relative;">
                    <div style="width:100%">
                        <p-multiSelect [options]="acct.properties" [(ngModel)]="acct.selectedProperties" 
                             optionLabel="propertyName" optionValue="propertyId"
                            placeholder="Selecione propriedades" [showClear]="true" display="chip"
                            [style]="{'width':'100%', 'min-width':'220px'}"
                            (onChange)="onSelectedPropertiesChange(acct)">

                            <ng-template let-item pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    <!-- Ícone Google maior -->
                                    <span
                                        style="display: flex; align-items: center; justify-content: center; width:32px; height:32px;">
                                        <i class="pi pi-google" style="font-size: 1.7rem; color: #4285F4"></i>
                                    </span>
                                    <!-- Nome e ID da propriedade -->
                                    <div style="line-height: 1;">
                                        <div class="font-semibold mb-1" style="font-size: 1rem;">{{item.propertyName}}
                                        </div>
                                        <div class="text-xs text-secondary-400" style="font-size: .82rem;">
                                            {{item.propertyId}}</div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-multiSelect>


                    </div>
                </div>
            </div>

            <!-- Aviso quando não tem propriedades -->
            <div *ngFor="let acct of ga4Accounts; trackBy: trackByUid" class="shadow-none mb-5"
                style="position:relative;">
                <p-message *ngIf="!acct.properties || !acct.properties.length" class="mt-3 cursor-pointer"
                    severity="warn" icon="pi pi-exclamation-triangle" (click)="onOpenGoogleAnalytics()"
                    text="Não foi encontrada nenhuma propriedade do GA4 associada a sua conta. Caso ainda não possua uma, configure sua conta no painel do Google Analytics 4. Mas se já possui uma, logo mais o GA4 deve lista-lá.">
                </p-message>
            </div>


        </ng-container>


        <!-- CTA conectar -->
        <ng-template #ctaGa4>
            <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none"
                style="height:160px;" (click)="onAddGa4Account()">
                <img src="assets/ga42.png" width="36" class="mb-3" />
                <span class="font-medium">Conectar conta do Ga4</span>
                <span class="text-sm text-500">Conecte uma conta do GA4 para começar</span>
            </div>
        </ng-template>
        </ng-container>

        <ng-template #sidebarSkeleton>
            <div class="card shadow-none">
                <p-skeleton width="8rem" height="1.5rem" styleClass="mb-4"></p-skeleton>
                <div class="flex align-items-center gap-2 mb-3">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <div class="flex-1">
                        <p-skeleton width="60%" height="1rem" styleClass="mb-1"></p-skeleton>
                        <p-skeleton width="40%" height="0.75rem"></p-skeleton>
                    </div>
                </div>
                <p-skeleton width="8rem" height="1.5rem" styleClass="mb-3"></p-skeleton>
                <p-skeleton width="100%" height="3rem"></p-skeleton>
            </div>
            <p-skeleton width="100%" height="160px"></p-skeleton>
        </ng-template>

    </div>

    <ng-template pTemplate="footer">
        <div style="display: flex; justify-content: flex-end; gap: 12px; padding: 0 1rem 1rem;">
            <button pButton pRipple label="Fechar" class="p-button-outlined"
                (click)="visibleChange.emit(false); close.emit()"></button>
            <ng-container *ngFor="let acct of ga4Accounts; trackBy: trackByUid">
                <button pButton pRipple label="Salvar" [loading]="isSavingDimensions" (click)="onSaveDimensions(acct)"
                    class="p-button-primary"></button>
            </ng-container>
        </div>
    </ng-template>

</p-sidebar>